// Determine API URL based on environment
let API_BASE_URL;

if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
  // Local development (localhost) - highest priority
  API_BASE_URL = 'http://localhost:3001';
} else if (typeof window !== 'undefined' && window.location.hostname === 'dev.sandiegogaming.com') {
  // Dev environment (when deployed to dev domain)
  API_BASE_URL = 'https://api.dev.sandiegogaming.com';
} else if (typeof window !== 'undefined' && window.location.hostname === 'sandiegogaming.com') {
  // Production environment (when deployed to production domain)
  API_BASE_URL = 'https://api.sandiegogaming.com';
} else if (process.env.REACT_APP_API_BASE_URL) {
  // Use explicit environment variable if set (for build-time configuration)
  API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
} else if (process.env.NODE_ENV === 'production') {
  // Fallback for production builds
  API_BASE_URL = 'https://api.sandiegogaming.com';
} else {
  // Default fallback
  API_BASE_URL = 'http://localhost:3001';
}

// Debug logging
console.log('Environment detection:');
console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('REACT_APP_API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);
console.log('window.location.hostname:', typeof window !== 'undefined' ? window.location.hostname : 'server-side');
console.log('Final API_BASE_URL:', API_BASE_URL);

export default API_BASE_URL; 